import requestMethods from '@/helpers/request/requestMethods';
import {
    feedHobeApiConfig,
    getHobeDataApiConfig,
    getHobeHintTextApiConfig
} from '@/constants/ApiUrls';

function getHobeData() {
    return requestMethods
        .get({
            routeConfig: getHobeDataApiConfig
        })
        .then((resp) => resp.data);
}

function getHobeHintText() {
    return requestMethods
        .get({
            routeConfig: getHobeHintTextApiConfig
        })
        .then((resp) => resp.data);
}

function feedHobe({ foodId }) {
    return requestMethods.post({
        routeConfig: feedHobeApiConfig,
        data: {
            food_id: foodId
        }
    });
}

export { getHobeData, getHobeHintText, feedHobe };
